(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
"use strict";

var isType = exports.isType = function (type, value) {
  return typeof value === type;
};
var isObject = exports.isObject = function (value) {
  return isType("object", value);
};
var isString = exports.isString = function (value) {
  return isType("string", value);
};
exports.__esModule = true;
}).call(this,require("IrXUsu"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/dist/isType.js","/dist")